import { render, staticRenderFns } from "./KegiatanTableDetails.vue?vue&type=template&id=7bbf5204&"
import script from "./KegiatanTableDetails.vue?vue&type=script&lang=js&"
export * from "./KegiatanTableDetails.vue?vue&type=script&lang=js&"
import style0 from "./KegiatanTableDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports